import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, InputNumber, Modal, Spin } from "antd";
import React, { useState } from "react";
import EditKpiProgressApi from "../../../api/kpi-progress/EditKpiProgresApi";
import EditTargetProgressApi from "../../../api/target-progress/EditTargetProgressApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

function EditKpiProgressModal(props) {
  const [submit, setSubmit] = useState(false);
  const [valuesChanged, setValuesChanged] = useState(false);

  function handleCancel() {
    setSubmit(false);
    setValuesChanged(false);

    props.handleCancel();
  }

  async function onFinish(value) {
    setSubmit(true);
    const apiResponse = await EditKpiProgressApi(
      props.progress?.progressId,
      value.target
    );

    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "success") {
      openNotificationSuccess("bottomRight", "Progress edited successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't edit progress. Try again later."
      );
    }
    handleCancel();
  }

  return (
    <Modal
      title="Edit progress"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="editProgress"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        initialValues={{
          target: props.progress?.target,
        }}
        onValuesChange={() => {
          setValuesChanged(true);
        }}
      >
        <Form.Item label="Target" name="target">
          <InputNumber placeholder="Target" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={props.handleCancel}>
              Cancel
            </Button>
            <Button
              className="btn w-32"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit || !valuesChanged}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default EditKpiProgressModal;
